"use client";

import { ArrowUpRight, CircuitBoard, Cpu, Layers, Microchip, Package, TrendingUp, Wrench } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SpecializedIndustryFocus() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: introRef,
    isVisible: introVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const headingWords = ["Strategic,", "talent", "acquisition."];
  const capabilities = [{
    index: "01",
    title: "Technology Sector",
    description: "Connecting visionary software engineers and product leaders with high-growth firms. Precision-matched candidates for your specific stack.",
    icon: CircuitBoard,
    span: "lg:col-span-5",
    featured: true
  }, {
    index: "02",
    title: "Financial Services",
    description: "Authenticated executive search for banking, fintech, and investment management roles with full confidentiality.",
    icon: Package,
    span: "lg:col-span-3",
    featured: false
  }, {
    index: "03",
    title: "Healthcare Leadership",
    description: "Expert talent audits to identify clinical and administrative leaders before your next expansion.",
    icon: Layers,
    span: "lg:col-span-3",
    featured: false
  }, {
    index: "04",
    title: "Operations Support",
    description: "Micro-scale talent restoration for fine-tuned organizational structures and administrative efficiency.",
    icon: Microchip,
    span: "lg:col-span-3",
    featured: false
  }, {
    index: "05",
    title: "Executive Onboarding",
    description: "Leadership integration, cultural alignment, and first-month validation. We bridge the gap between new hire and high-impact contributor.",
    icon: Cpu,
    span: "lg:col-span-4",
    featured: true
  }, {
    index: "06",
    title: "Growth Strategy",
    description: "Complete talent mapping packages prepared for seamless organizational scaling and transition.",
    icon: TrendingUp,
    span: "lg:col-span-4",
    featured: false
  }];
  return <section data-section-id="5197" id="specialized-industry-focus" className="bg-background text-foreground py-24 md:py-32 lg:py-44 px-6 md:px-10 lg:px-16 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        {}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8 mb-16 md:mb-24 lg:mb-32">
          

          
        </div>

        {}
        <div ref={gridRef} className="grid grid-cols-1 lg:grid-cols-12 gap-5 md:gap-6">
          {capabilities.map((cap, i) => {
          const Icon = cap.icon;
          return <Card data-index={i} key={cap.index} className={`group relative ${cap.span} p-8 md:p-10 border border-border bg-card text-card-foreground rounded-lg transition-all duration-500 ease-out hover:-translate-y-1 cursor-pointer overflow-hidden ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"} ${cap.featured ? "lg:min-h-[440px]" : "lg:min-h-[320px]"}`} style={{
            transitionDelay: gridVisible ? `${i * 100}ms` : "0ms"
          }} onMouseEnter={e => {
            e.currentTarget.style.borderColor = "var(--primary)";
          }} onMouseLeave={e => {
            e.currentTarget.style.borderColor = "var(--border)";
          }}>
                {}
                <span className="absolute top-6 right-7 font-mono text-xs tracking-widest" style={{
              color: "var(--primary)"
            }}>
                  {cap.index}
                </span>

                <div className="flex flex-col h-full">
                  {}
                  <div className={`flex items-center justify-center rounded-lg mb-8 transition-colors duration-500 ${cap.featured ? "h-32 md:h-40" : "h-20 md:h-24"}`} style={{
                backgroundColor: "var(--muted)"
              }}>
                    <Icon className={`${cap.featured ? "size-16 md:size-20" : "size-10 md:size-12"} transition-transform duration-500 group-hover:scale-110`} style={{
                  color: "var(--primary)"
                }} strokeWidth={1.25} />
                  </div>

                  {}
                  <h3 className={`font-default font-serif font-light leading-tight mb-4 transition-colors duration-300 text-foreground group-hover:text-[var(--primary)] ${cap.featured ? "text-2xl md:text-3xl" : "text-xl md:text-2xl"}`}>
                    {cap.title}
                  </h3>

                  {}
                  <p className="text-sm leading-relaxed text-foreground/65 font-default mb-6 flex-grow">
                    {cap.description}
                  </p>

                  {}
                  <Link to="/JobBoardPage" className="inline-flex items-center gap-2 font-mono text-xs tracking-[0.15em] uppercase text-foreground transition-colors duration-300 group-hover:text-[var(--primary)]">
                    <span>Explore</span>
                    <ArrowUpRight className="size-3.5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </Link>
                </div>
              </Card>;
        })}
        </div>

        {}
        <div className="mt-20 md:mt-24 flex flex-col md:flex-row items-start md:items-center justify-between gap-6 pt-12 border-t border-border">
          <p className="font-serif font-light text-xl md:text-2xl text-foreground/80 max-w-xl leading-snug">
            A bespoke partnership begins with a single conversation.
          </p>
          <Button asChild size="lg" className="rounded-lg px-8 h-12 font-mono text-xs tracking-[0.15em] uppercase" style={{
          backgroundColor: "var(--primary)",
          color: "var(--primary-foreground)"
        }}>
            <Link to="/EmployersPage">
              Begin a Partnership
              <ArrowUpRight className="size-4 ml-1" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}